// extracted by mini-css-extract-plugin
module.exports = {"spinner":"overlay_spinner__1qZGQ","spin":"overlay_spin__3p6jy"};